import { FoodfluenceLocation, GetCampaignLocationsResponse } from '@foodfluence/shared';
import { apiRequest } from './apiUtils';

/**
 * Get locations for a campaign
 */
export const getLocationsForCampaign = async (locationIds: string[]): Promise<GetCampaignLocationsResponse> => {
  try {
    const response = await apiRequest<GetCampaignLocationsResponse>({
      method: 'POST',
      endpoint: '/campaigns/locations',
      data: { locationIds }
    });
    return response;
  } catch (error) {
    console.error('Error fetching campaign locations:', error);
    return {
      success: false,
      data: [],
      count: 0,
      error: error instanceof Error ? error.message : 'Failed to fetch campaign locations'
    };
  }
};
